var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',{staticClass:"pt-3",attrs:{"cols":"12"}},[_c('div',_vm._l((_vm.chips),function(chip){return _c('v-chip',{key:chip.key,staticClass:"ma-1",attrs:{"color":"orange","text-color":"white","small":"","close":""},on:{"click:close":function($event){return _vm.$emit('remove', chip)}}},[_vm._v(" "+_vm._s(chip.label)+" ")])}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }